import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import HomeBanner2 from "../ones/HomeBanner2";
import ServicesBanner1 from "../ones/ServicesBanner1";
import data from "../assets/banner6.jpg";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<>
				<div className="MainBodySection mb-5">
					<div className="container">
						<div className="row">
							<div className="col-md-12">
								<h3 className="main-section-title">
									ICT CONSULTANCY
								</h3>
							</div>

							<div className="col-md-12 bg-surface rounded p-3">
								<h5 className="font-semi-bold text-dim py-3">We consult for high-end technology implementation at clients’ site or implementation of new technology according to the clients’ requirement or upgrading, enhancing the existing facilities in the clients end with the new technology integrated with the existing one.</h5>
								<img 
									style={{
										width:"100%",
										height:"auto"
									}}
									src={data} 
								/>
								<div>
									<h6 className="font-bold text-light bg-primary rounded p-2 my-3">
										BOSTON offers a full range of consulting services to help analyze your business requirements for effective implementation of solutions. Our consulting services cover: 
									</h6>
									<h5
										style={{
											borderLeft:"5px solid var(--primaryColor)",
											padding: "10px"
										}}
									>
										• Strategy planning<br/>
										• Assessment<br/>
										• Procurement<br/>
										• Re-engineering solutions<br/>
										• Planning, audits, best practices etc.

									</h5>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}